import { createBillingApiRequest } from '@/utils/api'
import { HttpMethod } from '@/constants/utils'
import { PRODUCT } from '@/utils'

import type { GetPricePreview } from './interfaces'

const getPricePreview = ({
  price,
  productType = PRODUCT.LiveChat,
}: GetPricePreview) => {
  const params = new URLSearchParams({
    price: `${price}`,
  })

  return createBillingApiRequest({
    method: HttpMethod.GET,
    path: `/price_preview/${productType}?${params}`,
  })
}

export default { getPricePreview }
